import Alpine from 'alpinejs';
// import Splide from 'alpine-splide';
import Splide from './components/Splide';
import intersect from '@alpinejs/intersect';
import collapse from '@alpinejs/collapse';
//import masonry from 'alpinejs-masonry';
//import Masonry from 'masonry-layout';



// FlexMasonry.init('.masonry', {
//     responsive: true,
// 	breakpointCols: {
//         'min-width: 1500px': 3,
//         'min-width: 1200px': 3,
//         'min-width: 992px': 3,
//         'min-width: 768px': 2,
//         'min-width: 576px': 2,
//     },
//     numCols: 3
// });



// export { Splide as default } from './components/Splide';

// import { Splide } from '@splidejs/splide';
Alpine.data('Splide', Splide);
// import { Intersection } from '@splidejs/splide-extension-intersection';

window.Alpine = Alpine;

Alpine.plugin(intersect);
Alpine.plugin(collapse);
//Alpine.plugin(masonry);
Alpine.start();



// window.fecthMasonry = function (container, items, columns) {
//     var CONTAINER_EL = document.querySelector("#" + container);
//     var WRAPPER_CONTAINER_EL = CONTAINER_EL.parentNode;
//     var ITEMS_ELS = document.querySelectorAll("." + items);
//     CONTAINER_EL.parentNode.removeChild(CONTAINER_EL);
//     var NEW_CONTAINER_EL = document.createElement('div');
//     NEW_CONTAINER_EL.setAttribute('id', container);
//     NEW_CONTAINER_EL.classList.add('masonry-layout', "columns-" + columns);
//     WRAPPER_CONTAINER_EL.appendChild(NEW_CONTAINER_EL);
//     for (var i = 1; i <= columns; i++) {
//         var COLUMN = document.createElement('div');
//         COLUMN.classList.add("masonry-column-" + i);
//         NEW_CONTAINER_EL.appendChild(COLUMN);
//     }
//     var countColumn = 1;
//     ITEMS_ELS.forEach(function (item) {
//         var col = document.querySelector("#" + container + " > .masonry-column-" + countColumn);
//         col.appendChild(item);
//         countColumn = countColumn < columns ? countColumn + 1 : 1;
//     });
// };

// async function fetchDataAsync(url) {
//     const response = await fetch(url);
//     console.log(await response.json());
// }

// init with selector
// var grid  = document.querySelector('.masonry');
// var msnry = new Masonry( grid, {
// 	itemSelector: '.grid-item',
// 	columnWidth: '.grid-sizer'
//   });

document.addEventListener( 'DOMContentLoaded', function() {
	// let bricks = document.querySelectorAll('.brick');
	// if (bricks.length > 0) {
	// 	// fecthMasonry('masonry', 'brick', 3);
	// }

// 	if (document.querySelectorAll('.splide').length) {
		// var splide = new Splide('.splide', {
		// 	autoplay: 'pause',
		// 	type: 'loop',
		// 	speed: 600,
		// 	pagination: true,
		// 	intersection: {
		// 		inView: {
		// 			autoplay: true,
		// 		},
		// 		outView: {
		// 			autoplay: false,
		// 		}
		// 	}
		// });
	
// 		let activeBar;
	
// 		splide.on('active', Slide => {
// 			activeBar = document.querySelector('.splide__pagination__page.is-active')
// 			console.log('ab', activeBar);
// 		});
	
// 		splide.on('autoplay:playing', rate => {
// 			activeBar.style.width = `${rate * 100}%`
// 		});
	
// 		splide.mount( { Intersection } );
// 	}
});
